
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"4","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.258 7.617a2.42 2.42 0 00.43-.164.606.606 0 00.218-.195.921.921 0 00.14-.383c.037-.172.056-.44.056-.805V2.664c0-.333-.006-.602-.016-.805a1.189 1.189 0 00-.11-.484.57.57 0 00-.288-.273 2.054 2.054 0 00-.54-.157V.531l1.82-.07h.477v5.586c0 .448.021.76.063.937.041.172.12.305.234.399.12.088.313.166.578.234V8H.258v-.383z","fill":"currentColor"}})])
          )
        }
      }
    